import * as React from 'react';
import { Typography, Button, Popover, MenuItem, Stack, Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setPresentRoute } from '../../stateManagement/reducers/routesReducer';
import { pathContains } from '../../helpers';

interface IProps {
    title: string;
    navItems: any[];
    url: string;
    baseUri: string;

    callback?: () => any;
}

const MouseOverPopover: React.FC<IProps> = ({ title, navItems, url, baseUri, callback }) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [openTooltip, setOpenTooltip] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);
    const location = useLocation();
    const [presentPage, setPresentPage] = React.useState("");
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();


    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (index: number) => {
        setSelectedIndex(index);
        // You can add additional logic for what should happen when the item is clicked

        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const TooltipTitle = () => {
        return (
            <>
                {navItems.length > 0 && (
                    <Stack
                        alignItems="flex-start"
                        sx={{
                            width: '100%',
                        }}
                    >
                        {navItems.map((navItem, i) => (
                            <MenuItem
                                key={i}
                                onClick={() => {

                                    handleMenuItemClick(i)

                                    setPresentPage(navItem.url);
                                    dispatch(setPresentRoute(navItem.url));
                                    navigate(navItem.url, { replace: true });

                                    if (callback) {
                                        callback();
                                    }
                                }}
                                sx={{
                                    width: '100%',
                                    borderRadius: '0 !important',
                                    p: '.75rem',
                                    borderTop: i === 0 ? 'none' : 'solid white .0625rem !important',
                                    backgroundColor: pathContains(location.pathname, navItem.id) ? 'transparent' : 'transparent',
                                    '&:hover': {
                                        backgroundColor: pathContains(location.pathname, navItem.id) ? 'transparent !important' : 'transparent !important',
                                        color: 'info.primary',
                                    }
                                }}
                            >
                                <Typography
                                    noWrap
                                    variant="body1"
                                    sx={{
                                        fontSize: { xs: '.75rem', md: '.85rem', lg: '1rem' },
                                        cursor: 'pointer',
                                        color: pathContains(location.pathname, navItem.id) ? 'rgba(26, 189, 84, 1) !important' : 'white !important',
                                        '&:hover': { color: selectedIndex === i ? 'white' : 'rgba(26, 189, 84, 1) !important' }
                                    }}
                                >
                                    <b>{navItem.title.toUpperCase()}</b>
                                </Typography>
                            </MenuItem>
                        ))}
                    </Stack>
                )
                }
            </>
        );
    }


    return (
        <div>
            {
                (navItems.length === 0)

                &&

                <Typography
                    noWrap
                    variant="body1"
                    sx={{
                        cursor: 'pointer',
                        my: { xs: 1, md: 2 },
                        display: 'block',
                        fontSize: { xs: '.75rem', md: '.85rem', lg: '1rem' },
                        color: pathContains(location.pathname, baseUri) ? 'rgba(26, 189, 84, 1)' : 'white !important',
                        '&:hover': { color: 'rgba(26, 189, 84, 1) !important' }
                    }}
                    onClick={() => {
                        setPresentPage(url);
                        dispatch(setPresentRoute(url));
                        navigate(url, { replace: true });

                        if (callback) {
                            callback();
                        }
                    }}
                >
                    <b>{title.toUpperCase()}</b>
                </Typography>
            }
            {
                (navItems.length > 0)

                &&


                <Tooltip
                    title={<TooltipTitle />}
                    PopperProps={{
                        sx: {
                            width: 'fit-content !important',
                            overflowX: 'visible !important',
                            zIndex: '10000000000000',
                        },
                        modifiers: [
                            {
                                name: 'arrow',
                                enabled: false,
                                options: {
                                    element: '[data-popper-arrow]',
                                },
                            },
                        ],
                    }}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                p: '0 !important',
                                borderRadius: '0 0 1rem 1rem',
                                backgroundColor: 'rgba(5, 35, 16, 1)',
                                zIndex: '10000000000000',
                                width: 'fit-content !important',
                                minWidth: 'fit-content !important',
                                position: 'relative',
                            },
                        },
                    }}
                    onOpen={() => setOpenTooltip(true)}
                    onClose={() => setOpenTooltip(false)}
                >

                    <Typography
                        noWrap={false}
                        variant="body1"
                        sx={{
                            cursor: 'pointer',
                            my: { xs: 1, md: 2 },
                            display: 'block',
                            // '&:hover': {
                            //     backgroundColor: 'transparent',
                            //     color: 'primary'
                            // },
                            width: 'fit-content !important',
                            position: 'relative',
                            fontSize: { xs: '.75rem', md: '.85rem', lg: '1rem' },
                            minWidth: 'fit-content !important',
                            color: (pathContains(location.pathname, baseUri) || openTooltip) ? 'rgba(26, 189, 84, 1)' : 'white !important',
                            '&:hover': { color: 'rgba(26, 189, 84, 1) !important' }
                        }}
                    >
                        <b>{title.toUpperCase()}</b>
                    </Typography>
                </Tooltip>
            }
            {navItems.length > 0 && (
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        sx: {
                            p: '0 !important',
                            borderRadius: '0 0 1rem 1rem',
                            backgroundColor: 'rgba(5, 35, 16, 1)',
                            zIndex: '10000000000000'
                        },
                    }}
                    sx={{
                        zIndex: '10000000000000'
                    }}
                    onMouseLeave={handlePopoverClose}  // Close when the mouse leaves the popover
                >
                    <Stack
                        alignItems="flex-start"
                        sx={{
                            width: '100%',
                        }}
                    >
                        {navItems.map((navItem, i) => (
                            <MenuItem
                                key={i}
                                onClick={() => {

                                    handleMenuItemClick(i)

                                    setPresentPage(navItem.url);
                                    dispatch(setPresentRoute(navItem.url));
                                    navigate(navItem.url, { replace: true });

                                    if (callback) {
                                        callback();
                                    }
                                }}
                                sx={{
                                    width: '100%',
                                    borderRadius: '0 !important',
                                    p: '.75rem',
                                    borderTop: i === 0 ? 'none' : 'solid white .0625rem !important',
                                    backgroundColor: pathContains(location.pathname, navItem.id) ? 'transparent' : 'transparent',
                                    '&:hover': {
                                        backgroundColor: pathContains(location.pathname, navItem.id) ? 'transparent !important' : 'transparent !important',
                                        color: 'info.primary',
                                    }
                                }}
                            >
                                <Typography
                                    noWrap
                                    variant="body1"
                                    sx={{
                                        fontSize: { xs: '.75rem', md: '.85rem', lg: '1rem' },
                                        cursor: 'pointer',
                                        color: pathContains(location.pathname, navItem.id) ? 'rgba(26, 189, 84, 1) !important' : 'white !important',
                                        '&:hover': { color: selectedIndex === i ? 'white' : 'rgba(26, 189, 84, 1) !important' }
                                    }}
                                >
                                    <b>{navItem.title.toUpperCase()}</b>
                                </Typography>
                            </MenuItem>
                        ))}
                    </Stack>
                </Popover>
            )
            }
        </div >
    );
}

export default MouseOverPopover;
